import httpClient from '../api/httpClient';

export const getAllUsers = async () => {
  const response = await httpClient.get('/api/identity/UserManagement/GetAll');
  return response.data;
};

export const getUserById = async (id) => {
  const response = await httpClient.get(`/api/identity/UserManagement/GetById/${id}`);
  return response.data;
};

export const getAllRoles = async () => {
  const response = await httpClient.get('/api/identity/UserManagement/GetAllRoles');
  return response.data;
};

export const createUser = async ({ username, password, isActive, roles }) => {
  const response = await httpClient.post('/api/identity/UserManagement/Create', {
    username,
    password,
    isActive,
    roles,
  });
  return response.data;
};

export const updateUser = async ({ id, username, password, isActive, roles }) => {
  const body = { id, username, isActive, roles };
  if (password) body.password = password;
  const response = await httpClient.put('/api/identity/UserManagement/Update', body);
  return response.data;
};

export const deleteUser = async (id) => {
  const response = await httpClient.delete('/api/identity/UserManagement/Delete', { data: { id } });
  return response.data;
};

export default {
  getAllUsers,
  getUserById,
  getAllRoles,
  createUser,
  updateUser,
  deleteUser,
};


